'use client';

import { IBurgerButton } from '@/types/components/burgerButton';

export const BurgerButton: React.FC<IBurgerButton> = ({
  isMenuOpen,
  toggleMenu,
}) => {
  return (
    <button
    className="text-white lg:hidden flex items-center px-4 w-full md:h-10 sm:h-10 border border-white rounded overflow-hidden"
    onClick={toggleMenu}
      aria-label="Toggle navigation menu"
    >
      <svg
        className={`fill-current h-10 w-4 transform transition-transform duration-300 ${
          isMenuOpen ? 'rotate-90' : ''
        }`}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Menu</title>
        <path d="M0 3h20v2H0zM0 9h20v2H0zM0 15h20v2H0z" />
      </svg>
    </button>
  );
};
